<template>
  <v-carousel :show-arrows="false" hide-delimiters height="800" width="100%" app>
    <v-carousel-item v-for="(item,i) in items" :key="i" :src="item.src">
      <v-container style="height: 100%">
        <v-row align="start" justify="center" style="height: 100%; padding-top: 12rem">
          <v-col cols="12">
            <h1 
              class="animated fadeInDown delay-2.1s display-3 font-weight-light white--text text-center pb-3">
              {{titulouno}}</h1>
            <h1 
              class="animated fadeInDown delay-2.5s headline font-weight-light white--text text-center">
              {{titulodos}}</h1>
            <h1 
              class="animated fadeInDown delay-2.8s headline font-weight-light white--text text-center">
              {{titulotres}}</h1>
          </v-col>
        </v-row>
      </v-container>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          src: require("../assets/fondo.jpg")
        }
      ],
    };
  },
  props:[
    'titulouno',
    'titulodos',
    'titulotres'
  ]
};
</script>

<style>
  @import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.min.css";
</style>